import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { V2nodeApiService } from 'src/shared/services/v2node-api.service';

class CustomValidator {
  static validateDocument(control: FormControl) {
    if (control.value.name && control.value.type) {
      return null;
    } else {
      return {
        document: 'Erreur !'
      }
    }
  }
}

@Component({
  selector: 'create-request-template',
  templateUrl: './create-request-template.component.html',
  styleUrls: ['./create-request-template.component.scss']
})
export class CreateRequestTemplateComponent implements OnInit {
  public form: FormGroup;
  public controlArray: FormArray;
  public types: any[];
  public loading: boolean;
  public loadingPage: boolean;
  public isEdit: boolean;

  constructor(private fb: FormBuilder, private v2node: V2nodeApiService, private snackBar: MatSnackBar, private router: Router, private activatedRoute: ActivatedRoute) { }

  async ngOnInit(): Promise<void> {
    this.loadingPage = true;
    this.isEdit = this.activatedRoute.snapshot.data.edit;
    this.types = this.initializeTypes();

    this.form = this.fb.group({
      templateName: ['', Validators.required],
      documents: this.fb.array([])
    });
    this.controlArray = this.form.get('documents') as FormArray;

    if (this.isEdit) {
      const idTemplate = this.activatedRoute.snapshot.params.templateId;
      const template = await this.v2node.requestApi({ action: `/document-request-template/${idTemplate}` });
      this.form.get('templateName').setValue(template.templateName);

      template.documents.forEach(doc => {
        const control = new FormControl({ name: doc.name, type: doc.type }, CustomValidator.validateDocument);
        this.controlArray.push(control);
      })
    } else {
      this.addNewDocument();
    }

    this.loadingPage = false;
  }

  public addNewDocument(): void {
    const control = new FormControl({ name: null, type: 'application/pdf' }, CustomValidator.validateDocument);
    this.controlArray.push(control);
  }

  public removeDocument(index: number): void {
    this.controlArray.removeAt(index);
  }

  public applyName(control: FormControl, newName: string): void {
    control.setValue({ ...control.value, name: newName });
  }

  public applyType(control: FormControl, newType: string): void {
    control.setValue({ ...control.value, type: newType });
  }

  public async save() {
    this.loading = true;

    try {
      let message = '';
      if (this.isEdit) {
        const idTemplate = this.activatedRoute.snapshot.params.templateId;
        await this.v2node.requestApi({ action: `/document-request-template/${idTemplate}`, method: 'PUT', datas: this.form.value });
        message = 'Template modifié avec succès';
      } else {
        await this.v2node.requestApi({ action: '/document-request-template', method: 'POST', datas: this.form.value });
        message = 'Template créé avec succès';
      }

      this.snackBar.open(message, null, {
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        duration: 2000,
      });

      this.router.navigate(['home', 'document-request', 'request-template']);
    } catch (e) {
      this.snackBar.open('Une erreur est survenue lors de la création', null, {
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: ['danger-msg'],
        duration: 2000,
      });
      this.loading = false;
    }
  }

  private initializeTypes(): any[] {
    return [
      {
        name: 'PDF',
        type: 'application/pdf'
      },
      {
        name: 'Image',
        type: 'image/png'
      },
      {
        name: 'Vidéo',
        type: 'video/mp4'
      }
    ]
  }
}
